import { z } from "zod"

export const contactFormSchema = z.object({
  module: z.string().min(1, "Module is required"),
  email: z.string().email("Invalid email address"),
  message: z.string().min(1, "Message is required"),
  files: z.array(z.any()).optional(),
})

export type ContactFormValues = z.infer<typeof contactFormSchema> 